var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.919,
    height: 35.919,
    viewBox: "0 0 35.919 35.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "balance",
    transform: "translate(-0.002 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34629",
    "data-name": "Group 34629",
    transform: "translate(0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65349",
    "data-name": "Path 65349",
    d: "M35.861,21.9l.005,0-5.9-12.867,1.43-.712-.535-1.072-1.394.694-.189-.411a.6.6,0,0,0-1.088,0l-.168.368a7.7,7.7,0,0,0-3.239-.717H19.757v-1.2h1.2v-1.2H19.926l.43-1.722a2.468,2.468,0,1,0-4.789,0L16,4.789H14.968v1.2h1.2v1.2H11.14A7.7,7.7,0,0,0,7.9,7.9L7.73,7.534a.6.6,0,0,0-1.088,0l-.189.411-1.394-.7L4.523,8.321l1.43.715L.056,21.9A.585.585,0,0,0,0,22.15,4.2,4.2,0,0,0,4.192,26.34h5.986a4.2,4.2,0,0,0,4.191-4.191.585.585,0,0,0-.06-.248L8.4,8.986a6.512,6.512,0,0,1,2.744-.605h5.026v21.9l-2.044,2.044H11.975A3,3,0,0,0,8.982,35.32a.6.6,0,0,0,.6.6H26.342a.6.6,0,0,0,.6-.6,3,3,0,0,0-2.993-2.993H21.8l-2.044-2.044V8.381h5.029a6.512,6.512,0,0,1,2.744.605L21.608,21.9a.585.585,0,0,0-.054.25,4.2,4.2,0,0,0,4.191,4.191H31.73a4.2,4.2,0,0,0,4.191-4.191A.583.583,0,0,0,35.861,21.9ZM10.179,25.143H4.192a3,3,0,0,1-2.933-2.395H13.112A3,3,0,0,1,10.179,25.143Zm2.659-3.592H1.533l5.5-12a.591.591,0,0,0,.307,0ZM16.96,1.685a1.31,1.31,0,0,1,2,0,1.264,1.264,0,0,1,.232,1.091l-.5,2.013h-1.46l-.5-2.013A1.264,1.264,0,0,1,16.96,1.685Zm.4,5.5v-1.2h1.2v1.2Zm1.2,1.2V29.932h-1.2V8.381Zm5.388,25.143a1.8,1.8,0,0,1,1.694,1.2H10.281a1.8,1.8,0,0,1,1.694-1.2Zm-3.84-1.2H15.815l1.2-1.2h1.9ZM28.583,9.555a.409.409,0,0,0,.3-.013l5.5,12.008h-11.3ZM31.73,25.143H25.744a3,3,0,0,1-2.933-2.395H34.664A3,3,0,0,1,31.73,25.143Z",
    transform: "translate(-0.002 0.001)",
    fill: "#06233d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.4508451bdfeee2609f5112f14bbbf391.svg";
export { ForwardRef as ReactComponent };